<template>
  <div>
    <div class="md:h-full md:w-full pl-2 pr-2 mb-4">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Important notice;</h5>
      <p class="mb-2 text-x font-normal tracking-tight text-gray-900 dark:text-white"><b>HD Quality</b> files that has been generated on the <b>Simpleish Website</b> directly, will be store at our server for <b>2 hours.</b></p>
      <p class="mb-2 text-x font-normal tracking-tight text-gray-900 dark:text-white">You can <b>download</b> them if necessary before they will be <b>deleted</b>.</p>
      <div v-if="userFiles.total > 0">
        <div class="flex flex-col">
            <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-hidden shadow-md sm:rounded-lg">
                        <table class="min-w-full">
                            <thead class="bg-gray-50 dark:bg-gray-700">
                                <tr>
                                    <th v-for="(userFileHeader,index) in userFileHeaders" :key="index" scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                        {{userFileHeader.text}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in userFiles.data" :key="index"  class="text-left bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                    <!--<td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {{item.uuid}}
                                    </td>-->
                                    <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                      <img class="w-48 border-2 border-gray-100 rounded-lg" :src="item.path">
                                    </td>
                                    <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {{ item.created_at + ' GMT+0000' | moment('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone) | moment('MM-DD-YYYY, h:mm:ss a')}}
                                    </td>
                                    <td class="py-4 px-6 text-sm text-gray-500 whitespace-nowrap dark:text-gray-400">
                                        <a :href="item.path" :download="item.path" target="_blank">
                                          <v-btn class="primary"><v-icon>mdi-download</v-icon><b>Download File</b></v-btn>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        <nav aria-label="Page navigation">
          <ul class="inline-flex -space-x-px">
            <li v-if="userFiles.current_page !== 1">
              <a @click="getUserFiles(userFiles.current_page-1)" class="py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Previous</a>
            </li>
            <li v-for="index in userFiles.last_page" :key="index">
              <a v-if="index === userFiles.current_page" @click="getUserFiles(index)" aria-current="page" class="py-2 px-3 text-blue-600 bg-blue-50 border border-gray-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white">{{index}}</a>
              <a v-else @click="getUserFiles(index)" class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">{{index}}</a>
            </li>
            <li v-if="userFiles.current_page !== userFiles.last_page">
              <a @click="getUserFiles(userFiles.current_page+1)" class="py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Next</a>
            </li>
          </ul>
        </nav>
        </div>
      </div>
      <div v-else>
        <h5 class="m-4 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">No files to be shown.</h5>
        <span class="block m-4 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">You can use our background remover and purchase images via 
          <a @click="goToUpload">click here.</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import FileService from '../../services/file.service';

  export default {
    name: 'Files',

    components: {
      
    },

    data(){
      return {
        userFiles: [],
        userFileHeaders: [
          { text: 'Display', value: 'preview' },
          { text: 'Processed at', value: 'created_at' },
          { text: 'Action', value: 'path' }
        ]
      }
    },

    created(){
      this.base = 'http://localhost:8000';
      
      this.init();
    },

    methods: {
      init(){
        this.getUserFiles(1);
        this.loadFromStorage();
      },

      loadFromStorage() {
        try {
          this.userFiles = JSON.parse(localStorage.getItem('userFiles'));
        } catch(e) {
          localStorage.removeItem('userFiles');
        }
      },

      getUserFiles(page){
        FileService.getUserFiles(page).then(
          response => {
            this.userFiles = response.data.response.user_files;

            this.userFileList = JSON.stringify(this.userFiles);
            localStorage.setItem('userFiles', this.userFileList);
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      },

      goToUpload() {
        this.$router.push('/upload');
      },
    }
  }
</script>